import { h } from 'preact';
import styled from 'styled-components';
import { InfoContainer, TitleAndPlayButtonWrapper } from 'sites/expedia-dominican-republic/video-player/styles/styles';
import { VideoPromo } from 'sites/expedia-dominican-republic/inline-video/styles/styles';
import { MQUERY } from 'common/constants';

export default function SeriesLogo({ logoImg, altText }) {
    if(!logoImg) return '';

    return (
        <SeriesLogoImg  src={logoImg} alt={altText}  loading="lazy" />
    )
};

const SeriesLogoImg = styled.img`
    max-height: 6rem;
    position: absolute;
    bottom: 2rem;
    left: 2rem;
    z-index: 5;

    // inline video
    ${VideoPromo}.is-active & {
        opacity: 0;
        transition: opacity .5s ease-in-out;
    }

    // video player
    ${TitleAndPlayButtonWrapper} & {
        position: relative;
        bottom: initial;
        left: initial;
    }

    ${InfoContainer}.is-active & {
        opacity: 0;
        transition: opacity .5s ease-in-out;
    }

    @media ${ MQUERY.DESKTOP_SMALL } {
        max-height: 8rem;
        position: relative;
        bottom: initial;
        left: initial;
        transition: opacity .5s ease-in-out .5s;
    }
`;
